import { render, staticRenderFns } from "./TransactionsTrendsChart.vue?vue&type=template&id=4c2f7566"
import script from "./TransactionsTrendsChart.vue?vue&type=script&lang=ts"
export * from "./TransactionsTrendsChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports